module.exports = __webpack_public_path__ + "img/c.43cb0032.jpg";